<template>
	<section class="project__wrapper">
		<h4 class="project__name">
			<a :href="url" target="_blank">
				{{ name }}
			</a>
		</h4>
		<div class="project__description">
			{{ description }}
		</div>
	</section>
</template>
<script>
export default {
	props: ["name", "description", "url"],
};
</script>
<style lang="scss" scoped>
.project {
	&__wrapper {
		display: flex;
		flex-direction: column;
		border-bottom: 1px dashed #ccc;
		padding: 15px 0px;
	}
	&__name {
		font-size: 21px;
		line-height: 25px;
		font-weight: 500;
	}
	&__description {
		font-size: 13px;
		line-height: 16px;
		position: relative;
		margin-top: 5px;
		white-space: pre-wrap;
	}
}
</style>
